var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "bj-modal",
        {
          attrs: { size: "sm", title: "Complete Report" },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("div", { staticClass: "bg-grey-4 rounded p-2 mb-5" }, [
                _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n        Type: " +
                      _vm._s(_vm.inspection.type) +
                      "\n      "
                  )
                ]),
                _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n        Property: " +
                      _vm._s(_vm.inspection.property.short_address) +
                      " " +
                      _vm._s(
                        _vm.inspection.unit && _vm.inspection.unit.name
                          ? " - " + _vm.inspection.unit.name
                          : ""
                      ) +
                      "\n      "
                  )
                ]),
                _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n        Agent: " +
                      _vm._s(
                        _vm.get(_vm.inspection, "assignment.user.full_name") ||
                          _vm.get(_vm.inspection, "assignment.user.label")
                      ) +
                      "\n      "
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _vm._v("\n        Scheduled Date: "),
                    _vm.inspection.preferred_from ||
                    _vm.inspection.preferred_until
                      ? _c("SdDatetime", {
                          staticClass: "d-inline-flex",
                          attrs: {
                            value: _vm.inspection.preferred_from,
                            format:
                              _vm.isTimeRequired &&
                              _vm.inspection.preferred_until
                                ? "MM/DD/YY h:mmA"
                                : "MM/DD/YY",
                            "market-id":
                              _vm.inspection.property &&
                              _vm.inspection.property.market_id,
                            timezone:
                              _vm.inspection.property &&
                              _vm.inspection.property.timezone,
                            until: _vm.inspection.preferred_until
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n        Additional Notes: " +
                      _vm._s(_vm.inspection.instructions) +
                      "\n      "
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "row gutter-sm" },
                [
                  _c(
                    "q-field",
                    { staticClass: "col-6" },
                    [
                      _c("q-select", {
                        attrs: {
                          "float-label": "Type",
                          options: _vm.priceOptions
                        },
                        model: {
                          value: _vm.payload.price_key,
                          callback: function($$v) {
                            _vm.$set(_vm.payload, "price_key", $$v)
                          },
                          expression: "payload.price_key"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "col-6",
                      attrs: {
                        error: _vm.get(_vm.$v.payload, "agent_payout.$error"),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          prefix: "$",
                          "float-label": "Amount to pay agent",
                          type: "number"
                        },
                        model: {
                          value: _vm.payload.agent_payout,
                          callback: function($$v) {
                            _vm.$set(_vm.payload, "agent_payout", $$v)
                          },
                          expression: "payload.agent_payout"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "col-6",
                      attrs: {
                        error: _vm.get(_vm.$v.payload, "report_file.$error"),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "file",
                          placeholder: "Report file (PDF)",
                          accept: "application/pdf"
                        },
                        on: {
                          change: function(event) {
                            return (_vm.payload.report_file =
                              event.target.files[0])
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c("bj-inner-loading", {
                attrs: { label: "Saving", visible: _vm.loading }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-btn-group",
                { attrs: { rounded: "", flat: "" } },
                [
                  _c("q-btn", {
                    attrs: {
                      disable: _vm.loading,
                      rounded: "",
                      color: "primary",
                      icon: "save",
                      size: "lg",
                      outline: "",
                      label: "Complete Report",
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.complete($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }